"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("waypoints/lib/jquery.waypoints");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Collection_List = void 0;

var loading_markup = void 0;
var noun_modal = void 0;
var url_to_array = void 0;

loading_markup = require("./loading_markup").default;

noun_modal = require("./noun_modal").default;

url_to_array = require("../helpers/url_to_array").default;

Collection_List = function () {
  var Collection_List = function () {
    function Collection_List() {
      _classCallCheck(this, Collection_List);

      this.$collection_list = (0, _jquery2.default)("#collection_list");
      this.$profile_detail = (0, _jquery2.default)(".profile-detail");
      this.$footer = (0, _jquery2.default)("#footer");
      this.page = 2;

      this.append_loading();
      this.set_waypoint();
    }

    _createClass(Collection_List, [{
      key: "append_loading",
      value: function append_loading() {
        this.$profile_detail.append(loading_markup);
        return this.$loading = (0, _jquery2.default)(".loading");
      }
    }, {
      key: "set_waypoint",
      value: function set_waypoint() {
        var me = void 0;
        me = this;
        return this.$footer.waypoint({
          handler: function handler() {
            if (!me.finished) {
              me.$loading.removeClass("hidden");
              if (!me.fetching) {
                me.fetching = true;
                return _jquery2.default.ajax({
                  url: "//" + url_to_array[2] + location.pathname + "json/?page=" + me.page + "&limit=20",
                  type: "GET",
                  success: function success(data, status, xhr) {
                    me.fetching = false;
                    me.page = me.page + 1;
                    me.$collection_list.append(data);
                    me.$loading.addClass("hidden");
                    Waypoint.refreshAll();
                  },
                  error: function error(xhr, status, _error) {
                    me.fetching = false;
                    me.finished = true;
                    return me.$loading.addClass("hidden");
                  }
                });
              }
            }
          },

          offset: "110%"
        });
      }
    }]);

    return Collection_List;
  }();

  return Collection_List;
}();

(0, _jquery2.default)(document).ready(function () {
  var authentication = void 0;
  var on_finish = void 0;
  var on_load = void 0;
  var share = void 0;
  var share_modal = void 0;
  share_modal = {
    type: "share",
    style: "full-blur",
    authenticate: false
  };
  on_finish = function on_finish() {
    return (0, _jquery2.default)(".close-button").on("click", function (e) {
      e.preventDefault();
      return noun_modal.dismiss();
    });
  };
  return share = noun_modal.init(share_modal, (0, _jquery2.default)("body"), "click", on_load = on_finish, authentication = false, "button.share");
});

exports.default = Collection_List;